import React from "react";
import PropTypes from "prop-types";
import useStyles from "@hooks/useStyles";

import SwipeableViews from "react-swipeable-views";
import MobileStepper from "@material-ui/core/MobileStepper";

import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";
import { adjective as proAdjective } from "@language/provider";
import IconButton from "@material-ui/core/IconButton";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import Button from "@material-ui/core/Button";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import StarBorderOutlinedIcon from "@material-ui/icons/StarBorderOutlined";
import StarsIcon from "@material-ui/icons/Stars";
import PhotoOutlinedIcon from "@material-ui/icons/PhotoOutlined";
import VerifiedUserOutlinedIcon from "@material-ui/icons/VerifiedUserOutlined";
import useConstants from "@hooks/useConstants";
import LazyLoad from "@custom/LazyLoad";

const tutorialSteps = [
	{
		label: "San Francisco – Oakland Bay Bridge, United States",
		imgPath:
			"https://images.unsplash.com/photo-1537944434965-cf4679d1a598?auto=format&fit=crop&w=400&h=250&q=60",
	},
	{
		label: "Bird",
		imgPath:
			"https://images.unsplash.com/photo-1538032746644-0212e812a9e7?auto=format&fit=crop&w=400&h=250&q=60",
	},
	{
		label: "Bali, Indonesia",
		imgPath:
			"https://images.unsplash.com/photo-1537996194471-e657df975ab4?auto=format&fit=crop&w=400&h=250&q=80",
	},
	{
		label: "NeONBRAND Digital Marketing, Las Vegas, United States",
		imgPath:
			"https://images.unsplash.com/photo-1518732714860-b62714ce0c59?auto=format&fit=crop&w=400&h=250&q=60",
	},
	{
		label: "Goč, Serbia",
		imgPath:
			"https://images.unsplash.com/photo-1512341689857-198e7e2f3ca8?auto=format&fit=crop&w=400&h=250&q=60",
	},
];

const CostsPopular = () => {
	const classes = useStyles("Costs");

	const [activeStep, setActiveStep] = React.useState(0);
	const maxSteps = tutorialSteps.length;

	const handleNext = () => {
		setActiveStep((prevActiveStep) => prevActiveStep + 1);
	};

	const handleBack = () => {
		setActiveStep((prevActiveStep) => prevActiveStep - 1);
	};

	const handleStepChange = (step) => {
		setActiveStep(step);
	};

	const { header } = useConstants("CostsPopularViewModel");

	return (
		<Box
			component="section"
			minHeight={400}
			width="100%"
			pt={10}
			pb={12}
			pr={2}
			pl={2}
		>
			<Container maxWidth="md">
				<Box mb={4}>
					<Box
						component="h2"
						fontSize={{ xs: 22, sm: 24 }}
						fontWeight={700}
						lineHeight={"30px"}
						mt={0}
						mb={0}
					>
						{header}
					</Box>
					<Box color={"grey.700"} mt={2} lineHeight={1.5}>
						We've tracked millions of cost estimates for home improvement and
						repair projects to find their true cost. Check out our cost guides
						and price estimators below.
					</Box>
				</Box>

				{/*<Box p={{xs: "24px 0px", sm: "24px 8px"}}>*/}
				{/*    <Box display={"flex"} alignItems={"center"}>*/}

				{/*        <IconButton color={"secondary"} aria-label="Left" onClick={handleBack}*/}
				{/*                    disabled={activeStep === 0}>*/}
				{/*            <KeyboardArrowLeft/>*/}
				{/*        </IconButton>*/}

				{/*        <Box fontSize={40} display={{xs: "none", sm: "flex"}} alignItems={"center"}*/}
				{/*             justifyContent={"center"}>*/}
				{/*            {tutorialSteps[activeStep].icon}*/}
				{/*        </Box>*/}

				{/*        <Box display={"flex"} alignItems={{xs: "flex-start", sm: "center"}} flex={1}*/}
				{/*             flexDirection={{xs: "column", sm: "row"}} pl={{xs: 0, sm: 4}} pr={{xs: 0, sm: 2}}>*/}
				{/*            <Box fontSize={{xs: 12, sm: 14}} lineHeight={1.5} pr={{xs: 0, sm: 4}}*/}
				{/*                 pb={{xs: 2, sm: 0}}>*/}
				{/*                {tutorialSteps[activeStep].body}*/}
				{/*            </Box>*/}
				{/*            <Box flexShrink={0}>*/}
				{/*                <Button href={tutorialSteps[activeStep].url}*/}
				{/*                        onClick={tutorialSteps[activeStep].onClick} disableElevation*/}
				{/*                        variant="contained"*/}
				{/*                        color="primary">*/}
				{/*                    {tutorialSteps[activeStep].cta}*/}
				{/*                </Button>*/}
				{/*            </Box>*/}
				{/*        </Box>*/}
				{/*        <IconButton color={"secondary"} aria-label="Right" onClick={handleNext}*/}
				{/*                    disabled={activeStep === maxSteps - 1}>*/}
				{/*            <KeyboardArrowRight/>*/}
				{/*        </IconButton>*/}

				{/*    </Box>*/}
				{/*</Box>*/}

				<SwipeableViews
					index={activeStep}
					onChangeIndex={handleStepChange}
					enableMouseEvents
				>
					{tutorialSteps.map((step, index) => (
						<div key={step.label}>
							{Math.abs(activeStep - index) <= 2 ? (
								<LazyLoad>
									<img
										className={classes.img}
										src={step.imgPath}
										alt={step.label}
									/>
								</LazyLoad>
							) : null}
						</div>
					))}
				</SwipeableViews>
				<MobileStepper
					steps={maxSteps}
					position="static"
					variant="text"
					activeStep={activeStep}
					nextButton={
						<Button
							size="small"
							onClick={handleNext}
							disabled={activeStep === maxSteps - 1}
						>
							Next
						</Button>
					}
					backButton={
						<Button
							size="small"
							onClick={handleBack}
							disabled={activeStep === 0}
						>
							Back
						</Button>
					}
				/>
			</Container>
		</Box>
	);
};

CostsPopular.propTypes = {};
export default CostsPopular;
